import { lazy, Suspense } from 'react'
import QRLayout from '../layouts/QRLanding'
import LoadingState from '../components/LoadingState'

// FIXME: Move page to "pages/qr/InspectDevice.tsx".
const InspectDevice = lazy(() => import('../pages/dashboards/QRLanding/QrLandingIndex'))

// FIXME: Change path to "/qr/inspect-device" and move to "routes/qr.tsx".
export default [
  {
    path: '/inspect-device/:shortUUID',
    element: (
      <QRLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <InspectDevice />
        </Suspense>
      </QRLayout>
    )
  }
]
